import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

// Actions
import { getRegionNames } from "../../../actions/regions/RegionActions";
import {
  clearCityConfig,
  getCityConfig,
} from "../../../actions/org/OrgCityConfigActions";

// Constants and Utils
import { OrgCityConfigTypes } from "../../../constants/GeneralConstants";

// Components
import PageHeader from "../../../mavin/components/page-header/PageHeader";
import SingleCitySelectionForm from "../../../mavin/components/single-city-selection-form/SingleCitySelectionForm";
import { LoadingData } from "../../../pages/org/OrgUtils";
import CityConfigSidebar from "./CityConfigSidebar";
import {
  CityConfigDataSection,
  CityConfigDownloadTemplate,
  CitySelectSection,
  UploadCityConfigExcel,
} from "./CityConfigUtils";

/**
 * TouchPoints city config Page
 */
export default function TouchPointsCityConfigPage() {
  const dispatch = useDispatch();

  // State
  const [selectedCityId, setSelectedCityId] = useState("");

  // regions name list
  const regionsName = useSelector((state) => state.region.regionsName) || [];
  const regionNamesLoading = useSelector((state) => state.region.namesLoading);

  // single City-Selection-form
  const openSingleCitySelectionForm = useSelector(
    (state) => state.singleCitySelectionModal.openModal
  );

  useEffect(() => {
    dispatch(getRegionNames());
  }, [dispatch]);

  // clear config
  useEffect(() => {
    dispatch(clearCityConfig());
  }, [dispatch, selectedCityId]);

  // config type
  const { touchPoint } = OrgCityConfigTypes;

  // Functions
  function onSubmitCitySelectionForm(cityId) {
    setSelectedCityId(cityId);

    // get city config for mediaTypes
    dispatch(getCityConfig(cityId, touchPoint));
  }

  // page actions
  const pageActions = (
    <CityConfigDownloadTemplate
      selectedCityId={selectedCityId}
      configType={touchPoint}
    />
  );

  return (
    <>
      <CityConfigSidebar activePageUrl={"/city-config/touch-points"} />

      <div className="content-wrapper">
        <PageHeader
          title={"Touch Points"}
          shadow={true}
          actions={pageActions}
        />

        <div className="page-content">
          {/* regions list loading */}
          {regionNamesLoading && <LoadingData className="p-1" />}
          {!regionNamesLoading && (
            <>
              <div className="d-flex align-items-center justify-content-between border-bottom pb-3">
                <CitySelectSection
                  regionsName={regionsName}
                  selectedCityId={selectedCityId}
                />
                <UploadCityConfigExcel
                  selectedCityId={selectedCityId}
                  configType={touchPoint}
                />
              </div>

              {/* config data */}
              <CityConfigDataSection
                configType={touchPoint}
                selectedCityId={selectedCityId}
              />
            </>
          )}
        </div>
      </div>

      {/* MODALS */}
      {openSingleCitySelectionForm && (
        <SingleCitySelectionForm
          regionsName={regionsName}
          onSubmit={onSubmitCitySelectionForm}
          selectedCityId={selectedCityId}
        />
      )}
    </>
  );
}
